import styled from "styled-components"
import { Typography } from "@bracket/ui"
import { getTokenDefinition, type TokenIdentifier } from "@bracket/chainography";

import type { FunctionComponent, } from "react"


//@ts-ignore - remove if props added
export declare type TokenBadgeProps = {
	token: TokenIdentifier
};


export const TokenBadge: FunctionComponent<TokenBadgeProps> = ({
	token,
}) => {

	const tok = getTokenDefinition(token);

	return (
		<Brace>
			<Inner>
			<img src={tok.logoURI} alt={tok.symbol} />
			<Typography variant="p">{tok.label}</Typography>
			</Inner>
		</Brace>
	);

}


const Brace = styled.div`
	display: flex;
	flex-direction: row;
	flex: 0;
	img { 
		width: 30px;
		height: 30px;
	}

`

const Inner = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: .25rem;
	p {
		opacity: .35;
	}
`
